module.exports = __webpack_public_path__ + "c2dd1e656e4211e362a2fe3af3de9183.png";